import { useMemo } from 'react'
import { useLoading } from 'hooks'
import { useDocument } from 'services/api/firebase'
import { COLLECTIONS } from '__constants__'
import {} from 'domains/Ticket/hooks'

const useGetTicketInitialValues = (id) => {
  /* Fetching data using useDocument hook */
  const [ticket, ticketLoading] = useDocument({
    ref: id ? COLLECTIONS.TICKETS + '/' + id : null
  })

  /* Merge all fetched data */
  const initialValues = useMemo(
    () => ({
      ticket
    }),
    [ticket]
  )

  /* Merge all loading states */
  const loadings = useMemo(
    () => (id ? [!ticket, ticketLoading] : []),
    [id, ticket, ticketLoading]
  )

  /* Getting loading state using merged loadings */
  const loading = useLoading(loadings)

  return [initialValues, loading]
}

export default useGetTicketInitialValues
